import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { beginRyzeRealmWarp } from '../abilities/ryzeRealmWarp.js';
import { isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export function createRyze(id = 'ryze-1', team = 'red', x = 1700, y = 600) {
  const ryze = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 465,
    maxMp: 280,
    ad: 59,
    ap: 0,
    armor: 22,
    mr: 30,
    ms: 340,
    attackRange: 550,
    attackSpeed: 0.625,
    name: 'Ryze',
    radius: 20
  });

  ryze.realmWarpChannel = null;

  return ryze;
}

function applyArcaneMastery(caster) {
  ['qCooldown', 'wCooldown', 'eCooldown', 'rCooldown'].forEach(cdKey => {
    if (caster[cdKey] > 0) {
      caster[cdKey] = Math.max(0, caster[cdKey] - 1.0);
    }
  });
}

export function castRyzeQ(caster, targetX, targetY, projectiles, gameTime) {
  if (caster.mp < 40) return false;
  caster.mp -= 40;

  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const damage = 60 + (caster.ap || 0) * 0.45 + (caster.maxMp || 0) * 0.07;

  projectiles.push({
    id: `ryze-q-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * 1700,
    vy: Math.sin(angle) * 1700,
    range: 1000,
    traveled: 0,
    damage,
    damageType: 'magic',
    radius: 55
  });

  applyArcaneMastery(caster);
  return true;
}

export function castRyzeW(caster, target) {
  if (!target || target.isDead || caster.mp < 50) return false;
  if (!isWithinAbilityRange(caster, target, 550, caster)) return false;
  caster.mp -= 50;

  const damage = 60 + (caster.ap || 0) * 0.6 + (caster.maxMp || 0) * 0.045;
  target.takeDamage(damage, caster, 'magic');

  if (target.statusManager && target.statusManager.addEffect) {
    target.statusManager.addEffect(EFFECT_TYPES.ROOT, 1.5, 0, target.tenacity || 0);
  }

  applyArcaneMastery(caster);
  return true;
}

export function castRyzeE(caster, initialTarget, nearbyEntities = []) {
  if (!initialTarget || initialTarget.isDead || caster.mp < 35) return 0;
  if (!isWithinAbilityRange(caster, initialTarget, 550, caster)) return 0;
  caster.mp -= 35;

  const damage = 50 + (caster.ap || 0) * 0.35 + (caster.maxMp || 0) * 0.01;
  const validTargets = nearbyEntities.filter(e => e && !e.isDead && e.team !== caster.team);
  
  let currentTarget = initialTarget;
  let bounceCount = 0;
  const maxBounces = 5;
  const visited = new Set();

  while (currentTarget && bounceCount < maxBounces) {
    currentTarget.takeDamage(damage, caster, 'magic');
    currentTarget.mr = Math.max(0, currentTarget.mr - 12);
    visited.add(currentTarget.id);
    bounceCount++;

    const nextTarget = validTargets.find(e =>
      e.id !== currentTarget.id
      && isInAbilityCircle(e, currentTarget.x, currentTarget.y, 350, caster)
    );
    currentTarget = nextTarget;
  }

  applyArcaneMastery(caster);
  return bounceCount;
}

export function castRyzeR(caster, targetX, targetY) {
  if (!beginRyzeRealmWarp(caster, targetX, targetY)) return false;
  applyArcaneMastery(caster);
  return true;
}
